// removed by extract-text-webpack-plugin
module.exports = {"paymentForm":"payment-form__paymentForm-1vOqU","payOnline":"payment-form__payOnline-L-a5C blocks__huge-2XOet blocks__green-2w7kK blocks__button-1iODk"};


//////////////////
// WEBPACK FOOTER
// ./components/account/orders/current-order/action-panel/payment-form/payment-form.css
// module id = 748
// module chunks = 0